import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

/**
 *  @typedef RejectedNumber
 *  @property {"whatsappNumber" | `numero${"" | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}`} key - O identificador do campo rejeitado
 *  @property {String} name - O nome da pessoa que teve o número rejeitado
 *  @property {String} value - O número que foi fornecido e rejeitado
 */

/**
 * Define quais colunas serão renderizadas na tabela
 *
 * @type {Array<{
 *  dataField: keyof RejectedNumber,
 *  text: string
 *  formatter?: (_cell, row: RejectedNumber) => React.Element
 * }>}
 */
const columns = [
  {
    dataField: 'name',
    text: 'Nome da pessoa'
  },
  ,
  {
    dataField: 'key',
    text: 'Campo rejeitado',
    formatter: (_, row) => (
      <span>
        {row.key === 'whatsappNumber'
          ? 'Número do Whatsapp'
          : row.key === 'numero'
          ? 'Número'
          : row.key.startsWith('numero')
          ? `Número ${row.key.replace('numero', '')}`
          : row.key}
      </span>
    )
  },
  {
    dataField: 'value',
    text: 'Número fornecido'
  }
];

/**
 * Renderiza uma tabela mostrando os números de telefone ou whatsapp que não foram aceitos durante a importação no discador.
 *
 * @component
 * @param {Object} props
 * @param {Array<RejectedNumber>} props.rejectedNumbers - Uma lista de números rejeitados
 */
export function RejectedNumbersTable({ rejectedNumbers }) {
  return (
    <ToolkitProvider data={rejectedNumbers} keyField="name" columns={columns}>
      {(props) => (
        <BootstrapTable
          {...props.baseProps}
          bootstrap4={false}
        ></BootstrapTable>
      )}
    </ToolkitProvider>
  );
}
